import React from 'react';

function SecurityWarningPopup({ onClose }) {
  return (
    <div className="security-popup-overlay" onClick={onClose}>
      <div className="security-popup-content" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="security-popup-close" onClick={onClose}>
          <i className="bi bi-x-lg"></i>
        </button>

        {/* Icon */}
        <div className="security-popup-icon">
          <i className="bi bi-shield-exclamation"></i>
        </div>

        {/* Header */}
        <div className="security-popup-header">
          <div className="security-popup-brand-name">circana</div>
          <div className="security-popup-brand-subtitle">PUBLIC CIRCANA RELATIONS</div>
        </div>

        {/* Body */}
        <div className="security-popup-body">
          <div className="security-popup-greeting">Dear Circana members:</div>
          <div className="security-popup-message">
            Recently, some criminals have forged the identities of tutors and induced users to transfer cryptocurrencies to private wallet addresses, causing financial losses. To protect the safety of your assets, please be sure to obtain the payment address through the official website online customer service, and do not trust any wallet information sent privately by tutors.
          </div>
        </div>

        {/* Action Button */}
        <div className="security-popup-actions">
          <button className="security-popup-button" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}

export default SecurityWarningPopup;

